import React from "react"
import {FormControl, FormErrorMessage, FormLabel, Input} from "@chakra-ui/react"

import {IInputFormProps} from "./interfaces"

export function FormInput(props: IInputFormProps) {
    const {
        parentField,
        label,
        rules,
        initialValue,
        inputOptions,
        register,
        className,
    } = props

    const errors = parentField ? (props.errors[parentField] || {})[props.field] : props.errors[props.field]
    const field = parentField ? `${parentField}.${props.field}` : props.field

    return <FormControl isRequired={!!rules} isInvalid={errors} className={className}>
        <FormLabel htmlFor={field}>{label}</FormLabel>
        <Input defaultValue={initialValue} id={field} type="text" {...inputOptions}
               {...register(field, rules)}/>
        <FormErrorMessage>
            {errors && errors.message}
        </FormErrorMessage>
    </FormControl>
}